import { render, staticRenderFns } from "./AddProductModal.vue?vue&type=template&id=6b5e6450"
import script from "./AddProductModal.vue?vue&type=script&lang=ts"
export * from "./AddProductModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports